module.exports = __webpack_public_path__ + "static/img/hb_9-min.3969388.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_9-min.png
// module id = lCGa
// module chunks = 1